import { render, staticRenderFns } from "./iframe_add.vue?vue&type=template&id=5e4ca81a"
import script from "./iframe_add.vue?vue&type=script&lang=js"
export * from "./iframe_add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports